import { useLoader } from '@react-three/fiber';
import { SRGBColorSpace, Texture, TextureLoader } from 'three';

export function useTextures(urls: string): Texture;
export function useTextures(urls: string[]): Texture[];
export function useTextures(urls: string | string[]) {
  const output = useLoader(TextureLoader, urls);

  if (Array.isArray(output)) {
    output.forEach(t => {
      t.flipY = false;
      t.colorSpace = SRGBColorSpace;
    });
  } else {
    output.flipY = false;
    output.colorSpace = SRGBColorSpace;
  }
  return output;
}
